import { useState } from 'react';

import { CaretDown, CaretUp } from '@phosphor-icons/react/dist/ssr';
import classNames from 'classnames';

import { ButtonElement } from '../buttonElement/ButtonElement';
import type { CollapsibleElementProps } from './CollapsibleElement.types';

export function CollapsibleElement({
  children,
  className,
  showButtonLabel,
  hideButtonLabel,
  defaultOpen = false,
}: CollapsibleElementProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={classNames('flex flex-col', className)}>
      {open && children}
      <div className="flex justify-center w-full">
        <ButtonElement
          variant="default"
          onClick={() => setOpen((prev) => !prev)}
          className={classNames('w-full', open && 'mt-4')}
        >
          <span className="flex flex-row items-center justify-center w-full gap-2">
            {open ? hideButtonLabel || showButtonLabel : showButtonLabel}
            {open ? <CaretUp className="text-gray-900" size={16} /> : <CaretDown className="text-gray-900" size={16} />}
          </span>
        </ButtonElement>
      </div>
    </div>
  );
}
